import "./DashboardPage.css";
import AlertsTable from "../AlertsTable";
import { useTranslation } from "react-i18next";

const AlertsPage = () => {
  const { t } = useTranslation();
  return (
    <div className="dashboard-page">
      <div className="dashboard-header">
        <div>
          <h1>{t("alertsPage.title")}</h1>
          <p>{t("alertsPage.subtitle")}</p>
        </div>
      </div>
      <AlertsTable />
    </div>
  );
};

export default AlertsPage;
